<template>
    <div class="FaqBlock my-4">
        <div
            class="FaqBlock__icon relative flex cursor-pointer items-center px-0 py-[0.7rem] md:px-0 md:py-4"
            :class="{ 'FaqBlock__icon--expanded': expanded }"
            @click="toggle"
        >
            <div class="flex-1 pr-8 text-lg font-semibold md:text-xl">
                {{ question }}
            </div>
        </div>

        <transition
            enter-active-class="transition duration-100"
            enter-class="-translate-y-4 opacity-0"
            leave-active-class="transition duration-100"
            leave-to-class="-translate-y-4 opacity-0"
        >
            <div v-show="expanded" class="mb-8 pr-10">
                <slot />
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps({
    question: {
        type: String,
        required: true
    }
})

const expanded = ref(false)

const toggle = () => {
    expanded.value = !expanded.value
}
</script>

<style lang="postcss" scoped>
.FaqBlock__icon {
    &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        display: inline-block;
        width: 24px;
        height: 24px;
        background: linear-gradient(#000, #000), linear-gradient(#000, #000);
        background-position: center;
        background-size:
            50% 2px,
            2px 50%; /*thickness = 2px, length = 50% (25px)*/
        background-repeat: no-repeat;
    }

    &--expanded::after {
        background: linear-gradient(#000, #000), linear-gradient(transparent, transparent);
        background-position: center;
        background-size:
            50% 2px,
            2px 50%; /*thickness = 2px, length = 50% (25px)*/
        background-repeat: no-repeat;
    }
}
</style>
